import { useEffect } from 'react';
import { useBrandsOperations } from './useBrandsOperations';
import { useShowFavouriteBrands } from './useShowFavouriteBrands';
import { useIsAllowDependsOnContour } from 'entities/application';

export const useInitFavouriteBrands = () => {
  const { getFavouriteBrands } = useBrandsOperations();
  const showFavouriteBrands = useShowFavouriteBrands();
  const isAllowDependsOnContour = useIsAllowDependsOnContour();

  useEffect(() => {
    if (isAllowDependsOnContour && showFavouriteBrands) {
      getFavouriteBrands();
    }
  // eslint-disable-next-line
  }, [showFavouriteBrands, isAllowDependsOnContour]);
};
